<template>
	<v-main>
		<v-layout fill-height column>
			<v-container fluid flex-fill>
			</v-container>

		</v-layout>
		<TermsDetailsModal :dialog="termsDetailsDialog" :flag="termsFlag" @close="termsDetailsClose"/>
	</v-main>
</template>
<script>
import TermsDetailsModal from "@/components/terms/TermsDetailsModal.vue";

export default {
	data: () => ({
		termsDetailsDialog: false,
		termsFlag: null,
	}),
	mounted() {
    let flag = this.$route.query.flag
    // 기본 약관이 개인정보처리방침이 나오도록
    if (flag === null || flag === undefined || flag < 0) flag = 3
		this.termsFlag = Number(flag)
		this.termsDetailsOpen(this.termsFlag)
	}
	,components: {
		TermsDetailsModal
	},
	methods: {
		termsDetailsOpen(index) {
			this.termsFlag = index;
			this.termsDetailsDialog = true;
		},
		termsDetailsClose() {
			this.termsDetailsDialog = false;
			this.prevPage();
		},

	}
}
</script>
